import React, { Component } from 'react';

import classnames from 'classnames';

class NavContainer extends Component {
    render() {
        const {type, handleOnTypeModeChange} = this.props;
        return (
            <div className='container filter setting'>
                <WorkBtn selected={type} id='info-user' title='사용자관리' onClick={handleOnTypeModeChange} />
                {/* <WorkBtn selected={type} id='info-path' title='저장소관리' onClick={handleOnTypeModeChange} />
                <WorkBtn selected={type} id='info-ch' title='채널관리' onClick={handleOnTypeModeChange} />
                <WorkBtn selected={type} id='info-fmt' title='포맷관리' onClick={handleOnTypeModeChange} /> */}
            </div>
        );
    }
}

const WorkBtn = ({selected, id, title, onClick}) => {
    const buttonClasses = classnames('tab', {'selected': selected === id });
    const type = {
        type: 'button',
        className: buttonClasses,
        onClick: e => onClick(id)
    };
    return (
        <div className="nav-item">
            <button {...type}>{title}</button>
        </div>
    );
};

export default NavContainer;


// WEBPACK FOOTER //
// ./src/containers/setting/NavContainer.js